import React, { useState } from 'react';
import moment from 'moment';
import { isEmpty } from 'lodash';
import withGoBack from '../common/withGoBack';
import withOnline from '../common/withOnline';
import withTableName from '../common/withTableName';
import withNotify from '../common/withNotify';
import withLoader from '../common/withLoader';
import withViewDersDetails from '../common/withViewDersDetails';
import Bugsnag from '../helpers/bugsnag';
import ArrowRight from '../assets/images/arrow-right.png';
import DerSubmit from './Models/DerSubmit';
import { isStartsWithNumber } from '../common/globals';

const DersRow = (props) => {
  const [active, setActive] = useState(true);
  let dersSubmitModel = null;

  const _onRedirectTo = (path, data) => {
    try {
      const { setViewDersDetails } = props;
      if (window.disabledClick) {
        return false;
      }
      const {
        onRedirect, setTableName, table
      } = props;
      setTableName(table);

      if (active) {
        onRedirect(path, data);
        setTableName(table);
        setViewDersDetails(true);
      } else {
        setActive(true);
        setTableName(table);
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  };

  const {
    data: {
      DERNo, CustomerName, SurgeonName, DateExplanted, COMNo, Sync, Submited, CaseNo, RepCaseNo
    },
    online, onSubmit
  } = props;

  const onDerSubmit = (e, data) => {
    try {
      e.stopPropagation();
      dersSubmitModel = new window.bootstrap.Modal(window.$(`#derSubmitModal-${data.DERNo}`));
      dersSubmitModel.show();
    } catch (error) {
      Bugsnag.notify(error);
    }
  };

  const derNoFlag = isStartsWithNumber(DERNo);

  const onSubmitDer = async (derData) => {
    onSubmit(derData);
  };

  return (
    <>
      <section
        className="cards-section"
        onClick={() => _onRedirectTo(`/ders/der/${DERNo}`, props.data)}
      >
        <div className="container">
          <div className="row">
            <div className="col-12 cursor-pointer">
              <div className="card-block bg-card-filed">
                <div className="ders-card border-0">
                  <div className="row">
                    <div className="col-6">
                      <p className="time">{isEmpty(DateExplanted) ? moment(new Date()).format('MMM DD, YYYY')
                        : moment(DateExplanted).format('MMM DD, YYYY')}
                        {/*: moment(DateExplanted).format('MM/DD/YYYY')} */}
                        {
                          Submited === '0'
                          && (
                            <span
                              style={{ paddingLeft: '10px' }}
                              onClick={(e) => onDerSubmit(e, props.data)}
                            >
                              <img
                                src={ArrowRight}
                                width="20"
                                alt="icon"
                              />
                            </span>
                          )
                        }
                      </p>
                    </div>
                    <div className="col-6">
                      <div className="dropdown">{CaseNo || (RepCaseNo ? 'PENDING' : '')}</div>
                    </div>
                    <div className="col-6">
                      <p className="der-list mb-0">{CustomerName}</p>
                    </div>
                    <div className="col-6">
                      <p className="text-ellipsis der-list mb-0">DER # {!online && Sync === 1 ? '' : !derNoFlag ? '' : DERNo}</p>
                    </div>
                    <div className="col-6">
                      <p className="text-ellipsis der-list mb-0">{SurgeonName}</p>
                    </div>
                    <div className="col-6">
                      <p className="text-ellipsis der-list mb-0">PC # {COMNo}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <DerSubmit
        title="Submit DER"
        text="Are you sure you want to submit this DER?"
        onClickYes={() => onSubmitDer(props.data)} id={DERNo}
      />
    </>
  );
};

export default withGoBack(
  withOnline(
    withTableName(
      withNotify(
        withLoader(
          withViewDersDetails(
            DersRow
          )
        )
      )
    )
  )
);
